import { useQuery } from "@tanstack/react-query";
import { instance } from "api/apiBase";
import { ApplicationActivity } from "shared/app/ActivityLog/types";

export const activityLogsQueryKey = (
  applicationId: number | string,
  queryParams?: Record<string, string | string[]>
) => ["ACTIVITY_LOGS", applicationId, queryParams];

export const useActivityLogsController = (
  applicationId: string,
  queryParams?: Record<string, string | string[]>
) => {
  const activityLogsMeta = useQuery<ApplicationActivity[]>({
    queryKey: activityLogsQueryKey(applicationId, queryParams),
    queryFn: () =>
      instance
        .get(`portal/v1/applications/${applicationId}/activity_logs`, {
          params: queryParams
        })
        .then(({ data }) => data.activity_logs),
    enabled: Boolean(applicationId && applicationId !== "undefined")
  });

  return { activityLogsMeta };
};
